// departmentActions.js
import axios from "axios";
import {
  fetchDepartmentStart,
  fetchDepartmentSuccess,
  fetchDepartmentFailure,
  addDepartmentStart,
  addDepartmentSuccess,
  addDepartmentFailure,
  updateDepartmentStart,
  updateDepartmentSuccess,
  updateDepartmentFailure,
  deleteDepartmentStart,
  deleteDepartmentSuccess,
  deleteDepartmentFailure,
} from "../slicer/departmentSlice"

const getToken = () =>
  document.cookie
    .split("; ")
    .find((row) => row.startsWith("accessToken="))
    ?.split("=")[1];

// Helper function to get the auth headers
const getAuthHeaders = () => {
  const token = getToken();
  return token ? { headers: { Authorization: `Bearer ${token}` } } : {};
};
    
// Fetch departments
export const fetchDepartments = () => async (dispatch) => {
  dispatch(fetchDepartmentStart());
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/academicPage/getDepartment`,
      getAuthHeaders() // Added authentication headers
    );
    console.log(response.data); // Log the response to see the data
    dispatch(fetchDepartmentSuccess(response.data.data));
  } catch (error) {
    dispatch(
      fetchDepartmentFailure(
        error.response?.data?.message || "Failed to fetch departments"
      )
    );
  }
};

// Add a new department
export const addDepartment = (departmentInfo) => async (dispatch) => {
  dispatch(addDepartmentStart());
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/academicPage/addDepartment`,
      departmentInfo,
      getAuthHeaders() // Added authentication headers
    );
    // dispatch(addDepartmentSuccess(response.data.data));
    // Validate the response
    const newDepartment = response.data.data;
    if (newDepartment && newDepartment.id && newDepartment.department_name) {
      dispatch(addDepartmentSuccess(newDepartment));
    } else {
      throw new Error("Invalid department data returned from API");
    }
  } catch (error) {
    dispatch(
      addDepartmentFailure(
        error.response?.data?.message || "Failed to add department"
      )
    );
  }
};

// Update a department
export const updateDepartment = (id, updatedInfo) => async (dispatch) => {
  dispatch(updateDepartmentStart());
  try {
    console.log("Sending PUT request to update department:", id, updatedInfo);
    const response = await axios.put(
      `${process.env.REACT_APP_BACKEND_URL}/academicPage/updateDepartment/${id}`,
      updatedInfo,
      getAuthHeaders() // Added authentication headers
    );
    console.log("API response:", response.data); // Log the response data

    if (!response.data || !response.data.data) {
      throw new Error("Invalid response format");
    }

    dispatch(updateDepartmentSuccess(response.data.data));
  } catch (error) {
    console.error("Error in updateDepartment action:", error.response || error.message);
    dispatch(
      updateDepartmentFailure(
        error.response?.data?.message || "Failed to update department"
      )
    );
  }
};




// Delete a department
export const deleteDepartment = (id) => async (dispatch) => {
  dispatch(deleteDepartmentStart());
  try {
    await axios.delete(
      `${process.env.REACT_APP_BACKEND_URL}/academicPage/deleteDepartment/${id}`,
      getAuthHeaders() // Added authentication headers
    );
    dispatch(deleteDepartmentSuccess(id));
  } catch (error) {
    dispatch(
      deleteDepartmentFailure(
        error.response?.data?.message || "Failed to delete department"
      )
    );
  }
};